import { useLanguage } from '../../context/LanguageContext';

export default function GameFeedbackText({
  isMatching = false,
  isCorrect = true,
  hasFeedback = false,
  hasRoundFinished = false,
}) {
  const { t } = useLanguage();

  if (isMatching) {
    return (
      <div className="flex items-center justify-center gap-2 px-2">
        <div className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent motion-reduce:animate-[spin_1.5s_linear_infinite]" />
        <span className="text-blue">{t('matchingGuess')}</span>
      </div>
    );
  } else {
    const baseClasses = 'px-2 text-center';
    const colorClass = hasFeedback
      ? isCorrect
        ? 'text-green'
        : 'text-red'
      : 'text-subtitle-light dark:text-subtitle-dark';
    const text = hasFeedback
      ? isCorrect
        ? `${t('correctGuess')}`
        : `${t('incorrectGuess')}`
      : `${t('feedbacktext')}`;

    return !hasRoundFinished && <span className={`${baseClasses} ${colorClass}`}>{text}</span>;
  }
}
